import { SkeletonBox, SkeletonButton, SkeletonText, Space } from '@billy/design-system'
import { ReactElement } from 'react'

import * as Styled from './styles'

export const SkeletonIntegrationCard = (): ReactElement => (
  <Styled.SkeletonIntegrationCardWrapper>
    <Styled.SkeletonCardContentWrapper>
      <Styled.SkeletonCardImageWrapper>
        <SkeletonBox fullWidth fullHeight />
      </Styled.SkeletonCardImageWrapper>
      <SkeletonText fullWidth variant="h4" />
      <Space size="s16" />
      <Styled.SkeletonCardDescriptionWrapper>
        <SkeletonText width={170} variant="bodySM" />
        <Space size="s8" />
        <SkeletonText width={200} variant="bodySM" />
        <Space size="s8" />
        <SkeletonText width={180} variant="bodySM" />
        <Space size="s8" />
        <SkeletonText width={120} variant="bodySM" />
      </Styled.SkeletonCardDescriptionWrapper>
    </Styled.SkeletonCardContentWrapper>
    <Styled.SkeletonCardActionsWrapper>
      <SkeletonButton fullWidth />
    </Styled.SkeletonCardActionsWrapper>
  </Styled.SkeletonIntegrationCardWrapper>
)
